export default __webpack_public_path__ + "static/media/62f778d6d5a9bc6bd460fc9d0bc12556.svg";